import React, {FunctionComponent, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {Button, Callout, Intent} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

import {useSubscription} from '../../shared/hooks';
import {
  isCanceled,
  isFreePlan,
  isNoPlan,
  isPaid,
  isTrial,
  redirectToExternal,
  trialExpiresInDays,
  noOfDaysUntil,
} from '../../shared/components/subscription/utils';
import {subscriptionCustomerPortal} from '../../shared/services/subscriptionApi';
import config from '../../config';

interface TrialCalloutProps {

}

const TrialCallout: FunctionComponent<TrialCalloutProps> = ({

}: TrialCalloutProps) => {
  /*
   * Only show if there is subscription and it is:
   * - Trial
   * - Canceled
   * - Expired
   */
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const subscription = useSubscription();
  let expiresIn = trialExpiresInDays(subscription);
  const _isCanceled = isCanceled(subscription);
  const isExpired = expiresIn <= 0;
  const customerName = config.app.customer_name;

  if (subscription?.canceled_on) {
    //
    expiresIn = noOfDaysUntil(subscription?.expires_on as string);
  }

  const onClick = () => {
    if (isTrial(subscription) || (_isCanceled && !isExpired)) {
      /*
       * Go to customer portal
       */
      setLoading(true);
      subscriptionCustomerPortal()
        .then((data: any) => redirectToExternal(data.redirect_url, false))
    } else {
      history.push('/a/subscription');
    }
  }

  if (!subscription) {
    return null;
  } else if (isNoPlan(subscription) || (isPaid(subscription)) || (!_isCanceled && isFreePlan(subscription))) {
    return null;
  }

  let title = isExpired ? ('Your subscription has expired. ' +
    `To execute tasks and reports, you need an active ${customerName} subscription.`) :
    `Your trial expires in ${expiresIn} days.`

  let buttonText = isExpired ? 'Upgrade now' : 'Buy Now';

  const intent = _isCanceled ? Intent.WARNING : isExpired ? Intent.DANGER : Intent.PRIMARY;
  const icon = _isCanceled ? IconNames.WARNING_SIGN : isExpired ? IconNames.ERROR : IconNames.CLEAN;

  if (_isCanceled) {
    title = 'Your subscription has been canceled.';
    buttonText = 'Reactivate now';

    if (!isExpired) {
      title += ` It expires in ${expiresIn} days.`;
    }
  }

  return (
    <Callout
      title={title}
      icon={icon}
      intent={intent}
    >
      <Button
        text={buttonText}
        intent={intent}
        onClick={onClick}
        loading={loading}
      />
    </Callout>
  );
}

export default TrialCallout;
